import styles from "../styles/chat.module.scss";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Router, { useRouter } from "next/router";
import http from "../http";
import { useUserInfo } from "../context/ThemeContext";
import { ShowMessage } from "../components/ShowMessage/ShowMessage";
import LeftPannel from "../components/common/LeftPannel";
import ChatpdfBox from "../components/common/ChatpdfBox";
import { Spin } from "antd";
import LoadingIcon from "../components/Icon/LoadingIcon";
import React from "react";
import { useCommonData } from "../layout/ELayout";

interface threadType {
  thread_id: string;
  fileData: {
    file_id?: string;
    file_name?: string;
  };
  setFileData: (data: { file_id?: string; file_name?: string }) => void;
  setThread: (thread_id: string) => void;
}
const ThreadContext = createContext<threadType | undefined>(undefined);
export default function Index() {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const { commonData, changeCommonData } = useCommonData();
  const { userInfo, toggleUserInfo, getUserInfo } = useUserInfo();
  const chatBox = useRef<any>();
  const leftPannel = useRef<any>();
  const [thread_id, setThread_id] = useState<string>("");
  const [fileData, setFile] = useState({});
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      // 页面刷新之后取消threadId的连接
      const ids = JSON.parse(localStorage.getItem("threadIds") || "[]");
      ids.forEach(async (id: string) => {
        await cancleChat(id);
      });
      localStorage.setItem("threadIds", JSON.stringify([]));
    }
  }, []);
  useEffect(() => {
    //debugger
    if (router.isReady) {
      const token = localStorage.getItem("token");
      sessionStorage.setItem(
        "gitee_id",
        router.query?.gitee_id?.toString() || ""
      );
      sessionStorage.setItem(
        "github_id",
        router.query?.github_id?.toString() || ""
      );
      router.query?.bd_vid &&
        sessionStorage.setItem(
          "bd_vid",
          router.query?.bd_vid?.toString() || ""
        );
      router.query?.utm_source &&
        sessionStorage.setItem(
          "utm_source",
          router.query?.utm_source.toString()
        );
      router.query?.invite_code &&
        sessionStorage.setItem(
          "invite_code",
          router.query?.invite_code.toString()
        );
      if (userInfo?.login && token) {
        leftPannel.current && leftPannel.current?.getChatList();
        if (!router.query.thread_id) {
          chatBox.current?.createThread();
        } else {
          chatBox.current?.getChatLog(router.query.thread_id);
          setThread(router.query.thread_id as string);
        }
      }
    }
  }, [router.isReady, userInfo?.login]);
  const setThread = (str: string) => {
    setThread_id(str);
  };
  const setFileData = (data: { file_id?: string; file_name?: string }) => {
    setFile(data);
  };

  const chatItemClick = (thread_id: string) => {
    setThread(thread_id);
    chatBox.current?.getChatLog(thread_id);
  };

  const createNewChat = async () => {
    const token = localStorage.getItem("token");
    setIsLoading(true);
    chatBox.current?.createNewChat();
  };

  const cancleChat = (thread_id: string) => {
    //取消与后端的聊天
    return new Promise((resolve, reject) => {
      http
        .post("api/v1/chat/cancel", { thread_id: thread_id })
        .then((data: any) => {
          if (data.status) {
            resolve(true);
          } else {
            resolve(false);
            ShowMessage.error(data.message);
          }
        });
    });
  };

  const chat = useMemo(() => {
    return (
      <ChatpdfBox
        reLoadCancleChat={cancleChat}
        cancleChat={cancleChat}
        updateMenu={() => {
          leftPannel.current && leftPannel.current?.getChatList();
        }}
        ref={chatBox}
        repoClick={(isClose) => {
          if (window.innerWidth < 1920) {
            leftPannel.current && leftPannel.current?.onFlod(isClose);
          } else if (!isClose) {
            leftPannel.current && leftPannel.current?.onFlod(isClose);
          }
        }}
        gotoLogin={() => {
          changeCommonData({ showLogin: true });
        }}
      />
    );
  }, []);

  return (
    <>
      <div id="chatpdf" className={styles.chatpdf}>
        <LeftPannel
          createNewChat={createNewChat}
          chatItemClick={chatItemClick}
          onfoldClick={() => {
            setTimeout(() => {
              chatBox.current && chatBox.current?.reSizeChatWidth();
            }, 100);
          }}
          setLoading={(loading) => {
            setIsLoading(loading);
          }}
          handleLogin={() => {
            changeCommonData({ showLogin: true });
          }}
          logOut={() => {
            setTimeout(() => {
              toggleUserInfo({ ...userInfo, login: false });
              chatBox.current && chatBox.current?.createNewChat(true);
            }, 100);
          }}
          ref={leftPannel}
        ></LeftPannel>
        <ThreadContext.Provider
          value={{ thread_id, setThread, fileData, setFileData }}
        >
          {chat}
        </ThreadContext.Provider>
      </div>
      <Spin
        spinning={isLoading}
        indicator={<LoadingIcon size={48} />}
        fullscreen
      />
    </>
  );
}
export const useThread = (): threadType => {
  const context = useContext(ThreadContext);
  if (!context) {
    throw new Error("useThread must be used within a ThreadProvider");
  }
  return context;
};
